import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateQuizQuestionsMutationVariables = Types.Exact<{
  data: Types.UpdateQuizQuestionsInput;
}>;


export type UpdateQuizQuestionsMutation = { updateQuizQuestions?: { success?: boolean | null } | null };


export const UpdateQuizQuestionsDocument = /*#__PURE__*/ gql`
    mutation updateQuizQuestions($data: UpdateQuizQuestionsInput!) {
  updateQuizQuestions(data: $data) {
    success
  }
}
    `;

export function useUpdateQuizQuestionsMutation() {
  return Urql.useMutation<UpdateQuizQuestionsMutation, UpdateQuizQuestionsMutationVariables>(UpdateQuizQuestionsDocument);
};